import axios from '../axiosInstance'

const baseUrlOp='/operation'
const baseUrlOpNilling='/ob/billing'
const baseUrlReports='/Reports'
class TrackService{

    getDocumentDownload(details){
        return axios.post(baseUrlOp+'/getDocumentDownload',details)
    }
    savePdftoFolder(details){
        return axios.post(baseUrlOp+'/savePdftoFolder',details)
    }
    getTrackingDetailsOperation(details){
        return axios.post(baseUrlOp+'/getTrackingDetailsOperation',details)
    }
    getJobTrackingDetailsOperation(details){
        return axios.post(baseUrlOp+'/getJobTrackingDetailsOperation',details)
    }
    getBillPrintTo(){
        return axios.get(baseUrlOpNilling+'/getBillPrintTo')
    }
    getAllChargesList(consignmentId){
        return axios.get(baseUrlOp+'/getAllChargesList?consignmentId='+consignmentId)
    }
    getGstNo(jobNo){
        return axios.get(baseUrlReports+'/getGstNo?jobNo='+jobNo)
    }
    InvoiceBillPdfPrint(details){
        return axios.post(baseUrlReports+'/InvoiceBillPdfPrint',details)
    }

}

export default new TrackService()